import PropTypes from 'prop-types';
import React from 'react';
import ColoredButton from 'components/ColoredButton';
import FlexBox from 'flexbox-react';
import { CardActions } from 'react-toolbox';
import cx from 'classnames';
import formStyles from 'styles/form';

const addRefigureClass = cx([formStyles.leftButton, formStyles.actionButton]);

const RefigureActions = ({ addRefigureDetails, handleSubmit }) =>
  <FlexBox justifyContent="flex-end" flexWrap="wrap">
    <CardActions className={formStyles.actionsWrapper}>
      <ColoredButton
        className={addRefigureClass}
        responsive
        color="blue"
        label="ADD REFIGURE"
        onClick={addRefigureDetails}
      />
      <ColoredButton
        className={formStyles.actionButton}
        responsive
        color="green"
        label="SUBMIT REFIGURE(S)"
        onClick={handleSubmit}
      />
    </CardActions>
  </FlexBox>;

RefigureActions.propTypes = {
  addRefigureDetails: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default RefigureActions;



// WEBPACK FOOTER //
// ./client/app/screens/refigure/form/components/refigureActions.jsx